import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["favorites", "onChange", "useImportedColors", "importedColors", "limitedOptions"];
/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { Component } from 'react';
import I18n from 'I18n';
import { debounce } from 'underscore';
import { connect } from 'react-redux';
import styled from 'styled-components';

// @ts-expect-error no types yet
import ColorPickerPopoverBody from 'react-colorpicker/popover/ColorPickerPopoverBody';
import Routes from 'ContentUtils/Routes';
import { SUCCEEDED } from 'ContentUtils/constants/RequestStatus';
import { getBrandColors, getBrandColorsFetchStatus, getBusinessUnitId } from 'ContentData/selectors/branding';
import * as BrandSettingsActions from 'ContentData/actions/Branding';
import { getPantoneColors } from 'ContentData/selectors/pantone';
import { isNullOrUndefined } from 'ContentUtils/helpers/ObjectHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = suffix => `ContentComponents.cmv2.fields.color.${suffix}`;
const ColorPickerPopoverContainer = styled.div.withConfig({
  displayName: "ColorPickerPopover__ColorPickerPopoverContainer",
  componentId: "sc-2z1ev-0"
})(["width:300px;"]);
const ColorPickerModes = Object.freeze({
  ADVANCED: 'advanced',
  SIMPLE: 'simple'
});
const mapStateToProps = (state, props) => ({
  businessUnitId: getBusinessUnitId(state, props),
  favorites: getBrandColors(state),
  importedColors: getPantoneColors(state),
  favoritesFetchStatus: getBrandColorsFetchStatus(state)
});
const mapDispatchToProps = {
  fetchBrandColors: BrandSettingsActions.fetchBrandColors,
  fetchBusinessUnit: BrandSettingsActions.fetchBusinessUnit
};
const connector = connect(mapStateToProps, mapDispatchToProps);
class ColorPickerPopover extends Component {
  constructor(props) {
    super(props);
    this.handleColorChange = this.handleColorChange.bind(this);
    this.debouncedColorChange = debounce(props.onChange, 200);
    this.handlePickerModeChange = this.handlePickerModeChange.bind(this);
    this.state = {
      colorPickerMode: ColorPickerModes.SIMPLE
    };
  }
  get shouldFetchFavorites() {
    const {
      favorites,
      favoritesFetchStatus,
      useFavorites
    } = this.props;
    return useFavorites && favoritesFetchStatus !== SUCCEEDED && !favorites.length;
  }
  componentDidMount() {
    const {
      businessUnitId,
      contentId,
      fetchBrandColors,
      fetchBusinessUnit,
      contentCategoryName
    } = this.props;
    if (this.shouldFetchFavorites) {
      if (isNullOrUndefined(businessUnitId) && contentCategoryName && contentId) {
        fetchBusinessUnit(contentCategoryName, contentId);
      } else {
        fetchBrandColors(businessUnitId);
      }
    }
  }
  componentDidUpdate(prevProps) {
    const {
      businessUnitId,
      fetchBrandColors
    } = this.props;
    const {
      businessUnitId: prevBusinessUnitId
    } = prevProps;
    if (this.shouldFetchFavorites && businessUnitId !== prevBusinessUnitId) {
      fetchBrandColors(businessUnitId);
    }
  }
  handleColorChange({
    color,
    alpha
  }) {
    const {
      onChange,
      useDebounce
    } = this.props;
    const {
      colorPickerMode
    } = this.state;
    if (colorPickerMode === ColorPickerModes.ADVANCED && useDebounce) {
      this.debouncedColorChange({
        color,
        alpha
      });
      return;
    }
    onChange({
      color,
      alpha
    });
  }
  handlePickerModeChange({
    target: {
      value
    }
  }) {
    this.setState({
      colorPickerMode: value
    });
  }
  render() {
    const _this$props = this.props,
      {
        favorites,
        useImportedColors,
        importedColors,
        limitedOptions
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const importedHex = importedColors.map(color => color.hex);
    const favsWithImports = useImportedColors ? [...favorites, ...importedHex] : favorites;
    return /*#__PURE__*/_jsx(ColorPickerPopoverContainer, {
      children: /*#__PURE__*/_jsx(ColorPickerPopoverBody, Object.assign({
        editFavoritesLink: Routes.accountDefaults('branding/colors'),
        editFavoritesLabel: I18n.text(i18nKey('favoritesLabel')),
        favorites: favsWithImports,
        onChange: this.handleColorChange,
        onPickerModeChange: this.handlePickerModeChange,
        showFavoritesLink: !!favorites.length,
        showResetToDefault: false,
        useFavorites: !!favsWithImports.length,
        colorGrid: limitedOptions && limitedOptions.length ? limitedOptions : undefined
      }, rest))
    });
  }
}
ColorPickerPopover.defaultProps = {
  useDebounce: true,
  useFavorites: true,
  useImportedColors: false
};
export default connector(ColorPickerPopover);